import React from 'react';

/**
 * کاشی متنی پیش‌فرض — جای عکس تا وقتی عکس واقعی یا خروجی عکس‌ساز آماده شود.
 * گرادیان از پالت تم سایت + عنوان خوانا در وسط؛ هیچ‌وقت جای خالی نمی‌ماند.
 */
const PALETTE = [
  ['var(--primary, #2563eb)', 'color-mix(in srgb, var(--accent, #3b82f6), #000 18%)'],
  ['color-mix(in srgb, var(--primary, #2563eb), #000 12%)', 'var(--accent, #3b82f6)'],
  ['color-mix(in srgb, var(--accent, #3b82f6), #000 8%)', 'color-mix(in srgb, var(--primary, #2563eb), #000 24%)'],
];

function hash(str) {
  let h = 0;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export default function ImageFallback({ label = '', seed = '', className = undefined, style = {} }) {
  const [a, b] = PALETTE[hash(seed || label) % PALETTE.length];
  return (
    <div
      className={className}
      aria-hidden
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)`,
        color: '#fff',
        textAlign: 'center',
        padding: 12,
        fontWeight: 800,
        lineHeight: 1.7,
        fontSize: '0.85rem',
        overflow: 'hidden',
        ...style,
      }}
    >
      <span style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
        {label}
      </span>
    </div>
  );
}
